import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type ApprovePaymentBody = NonNullable<
  paths['/api/v1/payments']['post']['requestBody']
>['content']['application/json'];
export type ApprovePaymentResponse =
  paths['/api/v1/payments']['post']['responses'][201]['content']['application/json']['payment'];

export type GetPaymentListResponse =
  paths['/api/v1/payments']['get']['responses'][200]['content']['application/json']['payments'];

export type RequestRefundPaymentBody = NonNullable<
  paths['/api/v1/payments/{uuid}/cancel']['post']['requestBody']
>['content']['application/json'];
export type RequestRefundPaymentResponse =
  paths['/api/v1/payments/{uuid}/cancel']['post']['responses'][200]['content']['application/json']['payment'];

export type GetPayLetterCardBlocklistResponse =
  paths['/api/v1/payments/pay_letter_card_blocklist']['get']['responses'][200]['content']['application/json']['payLetterUnavailableCardIssuers'];

export type GetPayLetterAvailablePaymentMethodsResponse =
  paths['/api/v1/payments/pay_letter_payment_methods']['get']['responses'][200]['content']['application/json']['payLetterAvailablePaymentMethods'];

export async function ApprovePayment(body: ApprovePaymentBody): Promise<ApprovePaymentResponse> {
  const { data, error } = await client.POST('/api/v1/payments', {
    body,
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data.payment) throw new Error('Empty response when approving payment');
  return data.payment;
}

export async function getPaymentList(): Promise<GetPaymentListResponse> {
  const { data, error } = await client.GET('/api/v1/payments', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting payment list');
  return data.payments;
}

export async function requestRefundPayment(
  paymentId: string,
  body: RequestRefundPaymentBody
): Promise<RequestRefundPaymentResponse> {
  const { data, error } = await client.POST('/api/v1/payments/{uuid}/cancel', {
    params: {
      path: {
        uuid: paymentId
      }
    },
    body,
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when requesting refund payment');
  return data.payment;
}

export async function getPayLetterCardBlocklist(): Promise<GetPayLetterCardBlocklistResponse> {
  const { data, error } = await client.GET('/api/v1/payments/pay_letter_card_blocklist', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting pay letter card blocklist');
  return data.payLetterUnavailableCardIssuers;
}

export async function getPayLetterAvailablePaymentMethods(): Promise<GetPayLetterAvailablePaymentMethodsResponse> {
  const { data, error } = await client.GET('/api/v1/payments/pay_letter_payment_methods', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting pay letter available payment methods');
  return data.payLetterAvailablePaymentMethods;
}